(function (global) {
    define('LNRS/Components/Content/Panels/CookieDisclaimerAlert',["jquery", "vue", "eventManager"],
        function ($, Vue, eventManager) {

            var component = {
                mounted: function () {
                    if (document.cookie.indexOf("MyPage") <= -1 || this.getCookie("MyPage") !== "1") {
                        
                        $(this.$el).fadeIn(800, function () {
                            eventManager.trigger("CookieDisclaimerAlertIsShown");
                            this.$anchors = $(".score-anchorpoint");
                            if (this.$anchors.length > 0) {
                                var newValue = parseInt(getComputedStyle(this.$anchors.get(0))["top"], 10) - this.$el.offsetHeight;
                                this.$anchors.css("top", newValue + "px");
                            }
                            this.$pageWrapper = $(".page-wrapper");
                            if (this.$pageWrapper.length > 0) {
                                this.$pageWrapper.css("padding-top", parseInt($("header.score-header").height(), 10) + "px"); 
                            } 
                            $('body').addClass('cookie-active');
                        }.bind(this));
                    }
                    $(this.$el).attr("data-ux-state", "loaded").removeAttr("data-ux-args");
                },
                methods: {
                    btnClick: function (e) {
                        e.preventDefault();
                        this.setCookie("MyPage", "1", 365);
                        
                        $(this.$el).fadeOut(800, function () {
                            if (this.$anchors && this.$anchors.length > 0) {
                                this.$anchors.removeAttr("style");
                            }
                            if (this.$pageWrapper && this.$pageWrapper.length > 0) {
                                this.$pageWrapper.removeAttr("style");
                            }
                            eventManager.trigger("CookieDisclaimerAlertIsClosed");
                            $('body').removeClass('cookie-active');
                            $(this.$el).hide();
                        }.bind(this));
                    },
                    setCookie: function (cname, cvalue, exdays) {
                        var d = new Date();
                        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                        var expires = "expires=" + d.toUTCString();
                        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
                    },
                    getCookie: function (cname) {
                        var name = cname + "=";
                        var ca = document.cookie.split(';');
                        for(var i = 0; i < ca.length; i++) {
                            var c = ca[i];
                            while (c.charAt(0) === " ") {
                                c = c.substring(1);
                            }
                            if (c.indexOf(name) === 0) {
                                return c.substring(name.length, c.length);
                            }
                        }
                        return "";
                    }
                }
            };

            return function initCookieDisclaimerAlert(args) {
                component.el = args.scope;
                component.data = {
                    $anchors: null,
                    $pageWrapper: null
                };
                return new Vue(component);
            };
        });
})(this);
